import { type Roles } from "../interface/Roles";

import { axiosInstance } from "./axiosInstance";

export const getUserOrganization = async (userId: string): Promise<Roles> => {
  const response = await axiosInstance.get(`/api/v1/user-organization/${userId}`);
  const role =
    Array.isArray(response.data) && response.data.length > 0 ? response.data[0].role : "";
  return { role };
};
